import { SYSTEM_SETTINGS } from "src/routes";

export const BACKEND_ACCOUNT = '/account';
export const BACKEND_ACCOUNT_CREDENTIALS = `${BACKEND_ACCOUNT}/credentials`;
export const BACKEND_ACCOUNT_PHONE_NUMBER = `${BACKEND_ACCOUNT}/phone-number`;
export const BACKEND_ACCOUNT_PHONE_NUMBER_CONFIRM = `${BACKEND_ACCOUNT}/phone-number/confirm`;

export const BACKEND_ACCOUNT_PASSPORT = `${BACKEND_ACCOUNT}/passport`;
export const BACKEND_ACCOUNT_TYPE = `${BACKEND_ACCOUNT}/type`;
export const BACKEND_ACCOUNT_TYPE_CHANGES = `${BACKEND_ACCOUNT_TYPE}/changes`;
export const BACKEND_ACCOUNT_CARD = `${BACKEND_ACCOUNT}/card`;

export const BACKEND_ACCOUNT_EMAIL = `${BACKEND_ACCOUNT}/email`;
export const BACKEND_ACCOUNT_EMAIL_CONFIRM = `${BACKEND_ACCOUNT}/email/confirm`;

export const BACKEND_ACCOUNT_PRODUCT_SHORT = `${BACKEND_ACCOUNT}/products/search/short`;
export const BACKEND_ACCOUNT_PRODUCT_FULL = `${BACKEND_ACCOUNT}/products/search/full`;
export const BACKEND_ACCOUNT_PRODUCT_CART = `${BACKEND_ACCOUNT}/products/cart`;
export const BACKEND_ACCOUNT_PRODUCT_ORDER = `${BACKEND_ACCOUNT}/products/orders`;
export const BACKEND_ACCOUNT_PROVIDER_USER = `${BACKEND_ACCOUNT}/providers-users`;
export const BACKEND_ACCOUNT_PROVIDER_USER_HEALTH_CHECK = `${BACKEND_ACCOUNT}/providers-users-health-check`;

export const BACKEND_ACCOUNT_CLIENT = `${BACKEND_ACCOUNT}/clients`;
export const BACKEND_SOURCE_ACCOUNT_CLIENT = `${BACKEND_ACCOUNT}/source/clients`;

export const BACKEND_SIGN_IN = '/auth/sign-in';

export const BACKEND_SIGN_OUT = '/auth/sign-out';

export const BACKEND_ADMIN_USERS = '/admin/users';
export const BACKEND_ADMIN_USERS_CARDS = '/admin/users-cards';
export const BACKEND_SOURCE_USERS = '/admin/source/users';

export const BACKEND_SOURCE_PROVIDER = '/admin/source/providers';
export const BACKEND_SOURCE_BRAND = '/admin/source/brands';
export const BACKEND_SOURCE_APPLICATION = '/admin/source/applications';

export const BACKEND_PRODUCT_SHORT = '/search-service/products/short';
export const BACKEND_PRODUCT_FULL = '/search-service/products/full';

export const BACKEND_PRODUCT_CART = '/products/cart';

export const BACKEND_ADMIN_APPLICATION = '/admin/applications';
export const BACKEND_ADMIN_BRAND = '/admin/brands';
export const BACKEND_ADMIN_PROVIDER = '/admin/providers';
export const BACKEND_ADMIN_PROVIDER_BRAND = '/admin/providers-brands';
export const BACKEND_ADMIN_PROVIDER_USER = '/admin/providers-users';
export const BACKEND_ADMIN_APPLICATION_USER_RELATION = '/admin/applications-users-relations';

export const BACKEND_ADMIN_PROVIDER_PARSER_FILE = '/admin/provider-parser-file';
export const BACKEND_ADMIN_SOURCE_PROVIDER_PARSER_FILE = '/admin/source/provider-parser-file';

export const BACKEND_ADMIN_USERS_TYPES = '/admin/users-types';

export const BACKEND_USER_CLIENT = '/clients';

export const BACKEND_ADMIN_SYSTEM_SETTINGS = '/admin/system-settings';
export const BACKEND_ADMIN_SYSTEM_SETTINGS_TYPES = '/admin/system-settings-types';
export const BACKEND_ADMIN_SYSTEM_SETTINGS_USERS = '/admin/system-settings-users';
export const BACKEND_ADMIN_SYSTEM_SETTINGS_USERS_ACCOUNT_USER_TYPE = `${BACKEND_ADMIN_SYSTEM_SETTINGS_USERS}/${SYSTEM_SETTINGS.USERS_ACCOUNT_USER_TYPE}`;
export const BACKEND_ADMIN_SYSTEM_SETTINGS_SHIFTS = '/admin/system-settings-shifts';
export const BACKEND_ADMIN_SYSTEM_SETTINGS_SHIFTS_IS_NOTICE_USERS_BY_SHIFT_CHANGES = `${BACKEND_ADMIN_SYSTEM_SETTINGS_SHIFTS}/${SYSTEM_SETTINGS.SHIFTS_IS_NOTICE_USERS_BY_SHIFT_CHANGES}`;
export const BACKEND_ADMIN_SYSTEM_SETTINGS_SHIFTS_NOT_COUNTING_OVERWORK_TIME = `${BACKEND_ADMIN_SYSTEM_SETTINGS_SHIFTS}/${SYSTEM_SETTINGS.SHIFTS_NOT_COUNTING_OVERWORK_TIME}`;
export const BACKEND_ADMIN_SYSTEM_SETTINGS_REPORTS = '/admin/system-settings-reports';
export const BACKEND_ADMIN_SYSTEM_SETTINGS_REPORTS_PHOTO_NOT_ATTACHING_PENALTY = `${BACKEND_ADMIN_SYSTEM_SETTINGS_REPORTS}/${SYSTEM_SETTINGS.REPORTS_PHOTO_NOT_ATTACHING_PENALTY}`;
export const BACKEND_ADMIN_SYSTEM_SETTINGS_REPORTS_WRITING_DELAY_PENALTY = `${BACKEND_ADMIN_SYSTEM_SETTINGS_REPORTS}/${SYSTEM_SETTINGS.REPORTS_WRITING_DELAY_PENALTY}`;
export const BACKEND_ADMIN_SYSTEM_SETTINGS_BOOKKEEPING = '/admin/system-settings-bookkeeping';
export const BACKEND_ADMIN_SYSTEM_SETTINGS_BOOKKEEPING_BILL_CHANGES_CONSTRAINT = `${BACKEND_ADMIN_SYSTEM_SETTINGS_BOOKKEEPING}/${SYSTEM_SETTINGS.BOOKKEEPING_BILL_CHANGES_CONSTRAINT}`;
export const BACKEND_ADMIN_SYSTEM_SETTINGS_BOOKKEEPING_WORK_DAY_HOURS_COUNT = `${BACKEND_ADMIN_SYSTEM_SETTINGS_BOOKKEEPING}/${SYSTEM_SETTINGS.BOOKKEEPING_WORK_DAY_HOURS_COUNT}`;
export const BACKEND_ADMIN_SYSTEM_SETTINGS_CALENDAR = '/admin/system-settings-calendar';
export const BACKEND_ADMIN_SYSTEM_SETTINGS_CALENDAR_EVENT_COLOR_BIRTHDAY = `${BACKEND_ADMIN_SYSTEM_SETTINGS_CALENDAR}/${SYSTEM_SETTINGS.CALENDAR_EVENT_COLOR_BIRTHDAY}`;
export const BACKEND_ADMIN_SYSTEM_SETTINGS_CALENDAR_EVENT_COLOR_PROJECT = `${BACKEND_ADMIN_SYSTEM_SETTINGS_CALENDAR}/${SYSTEM_SETTINGS.CALENDAR_EVENT_COLOR_PROJECT}`;
export const BACKEND_ADMIN_SYSTEM_SETTINGS_AMOCRM = '/admin/system-settings-amocrm';
export const BACKEND_ADMIN_SYSTEM_SETTINGS_AMOCRM_CLIENT_ID = `${BACKEND_ADMIN_SYSTEM_SETTINGS_AMOCRM}/${SYSTEM_SETTINGS.AMOCRM_CLIENT_ID}`;
export const BACKEND_ADMIN_SYSTEM_SETTINGS_AMOCRM_CLIENT_SECRET = `${BACKEND_ADMIN_SYSTEM_SETTINGS_AMOCRM}/${SYSTEM_SETTINGS.AMOCRM_CLIENT_SECRET}`;

export const BACKEND_ADMIN_SOURCE_SYSTEM_SETTINGS_CALENDAR_EVENT_COLORS = '/admin-source/system-settings-calendar-event-colors';
